import { computed, ref } from 'vue';


export default {
  __name: 'UiInput',
  props: {
  value: {
    type: [String, Number],
    default: null,
  },
  placeholder: {
    type: String,
    default: null,
  },
  label: {
    type: String,
    default: null,
  },
  type: {
    type: String,
    default: 'text',
  },
  error: {
    type: String,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  rounded: {
    type: String,
    default: 'rounded-xl',
  },
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;





const valueLocal = computed({
  get() {
    return props.value;
  },
  set(newValue) {
    emit('input', newValue);
  },
});

const input = ref();

return { __sfc: true,props, emit, valueLocal, input }
}

}